import apiClient from './Api';
const PREFIX = '/video';

// #Video Page
const getTreeData = postData => {
  return apiClient({
    url: `${PREFIX}/getnode`,
    method: 'POST',
    data: postData
  });
};

const getFirstData = postData => {
  return apiClient({
    url: `${PREFIX}/getfirst`,
    method: 'POST',
    data: postData
  });
};

const deleteVideo = postData => {
  return apiClient({
    url: `${PREFIX}/delete`,
    method: 'POST',
    data: postData
  });
};

const deleteSingleVideo = postData => {
  return apiClient({
    url: `${PREFIX}/deletesingle`,
    method: 'POST',
    data: postData
  });
};

const ownReProcessVideo = postData => {
  return apiClient({
    url: `${PREFIX}/reprocessVideo`,
    method: 'POST',
    data: postData
  });
};

// #videoGeneration Page

const getDealerInfo = dealerId => {
  return apiClient({
    url: `${PREFIX}/dealerInfo`,
    method: 'POST',
    data: dealerId
  });
};

const saveVideoSettings = postData => {
  return apiClient({
    url: `${PREFIX}/saveVideoSettings`,
    method: 'POST',
    data: postData
  });
};

const saveSelectedMusic = postData => {
  return apiClient({
    url: `${PREFIX}/saveSelectedMusic`,
    method: 'POST',
    data: postData
  });
};

const uploadMusicFile = postData => {
  return apiClient({
    url: `${PREFIX}/uploadMusicFile`,
    method: 'POST',
    data: postData
  });
};

const deleteMusicFile = data => {
  return apiClient({
    url: `${PREFIX}/deleteMusicFile`,
    method: 'POST',
    data
  });
};

const uploadVideoFile = fileData => {
  return apiClient({
    url: `${PREFIX}/uploadVideoFile`,
    method: 'POST',
    data: fileData
  });
};

const deleteVideoFile = data => {
  return apiClient({
    url: `${PREFIX}/deleteVideoFile`,
    method: 'POST',
    data
  });
};

const toggleVoiceOver = data => {
  return apiClient({
    url: `${PREFIX}/toggleVoiceOver`,
    method: 'POST',
    data
  });
};

const convertTextToSpeech = text => {
  return apiClient({
    url: `${PREFIX}/convertTextToSpeech`,
    method: 'POST',
    data: text
  });
};

const deleteSpeech = data => {
  return apiClient({
    url: `${PREFIX}/deleteSpeech`,
    method: 'POST',
    data
  });
};

const getImageListDetail = data => {
  return apiClient({
    url: `${PREFIX}/getImageListDetail`,
    method: 'POST',
    data
  });
};

const uploadPngImages = data => {
  return apiClient({
    url: `${PREFIX}/uploadPngImages`,
    method: 'POST',
    data
  });
};

const deleteLowerSettingImages = data => {
  return apiClient({
    url: `${PREFIX}/deleteLowerSettingImages`,
    method: 'POST',
    data
  });
};

const updateImageDetails = data => {
  return apiClient({
    url: `${PREFIX}/updateImageDetails`,
    method: 'POST',
    data
  });
};

const uploadFontFiles = data => {
  return apiClient({
    url: `${PREFIX}/uploadFontFiles`,
    method: 'POST',
    data
  });
};

const editFontName = data => {
  return apiClient({
    url: `${PREFIX}/editFontName`,
    method: 'POST',
    data
  });
};

const deleteFontFile = data => {
  return apiClient({
    url: `${PREFIX}/deletefontfile`,
    method: 'POST',
    data
  });
};

const saveImageSettings = data => {
  return apiClient({
    url: `${PREFIX}/saveImageSettings`,
    method: 'POST',
    data
  });
};

/* // NOT IN USE
const getVideoExportStatus = postData => {
  return apiClient({
    url: `${PREFIX}/sent`,
    method: 'POST',
    data: postData
  });
};
const download = params => {
  return apiClient({
    url: `${PREFIX}/download?${params}`,
    method: 'GET',
    responseType: 'blob'
  });
};
*/

const saveVideoPhrase = data => {
  return apiClient({
    url: `${PREFIX}/savevideophrase`,
    method: 'POST',
    data
  });
};

const deleteVideoPhrase = data => {
  return apiClient({
    url: `${PREFIX}/deletevideophrase`,
    method: 'POST',
    data
  });
};

const massReProcess = postData => {
  return apiClient({
    url: `${PREFIX}/massreprocess`,
    method: 'POST',
    data: postData
  });
};

const VideoService = {
  getFirstData,
  getTreeData,
  deleteVideo,
  deleteSingleVideo,
  ownReProcessVideo,
  getDealerInfo,
  saveVideoSettings,
  saveSelectedMusic,
  uploadMusicFile,
  deleteMusicFile,
  uploadVideoFile,
  deleteVideoFile,
  toggleVoiceOver,
  convertTextToSpeech,
  deleteSpeech,
  getImageListDetail,
  uploadPngImages,
  deleteLowerSettingImages,
  updateImageDetails,
  uploadFontFiles,
  editFontName,
  deleteFontFile,
  saveImageSettings,
  saveVideoPhrase,
  deleteVideoPhrase,
  // getVideoExportStatus,
  // download
  massReProcess
};

export default VideoService;
